import { ComponentType } from '@angular/cdk/portal';

import { BaseIconComponent } from '../ui-kit/icons/base-icon.component';
import { AnimalInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/animal-insurance-icon.component';
import { BuildingInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/building-insurance-icon.component';
import { BusinessAccidentInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-accident-insurance-icon.component';
import { BusinessBuildingInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-building-insurance-icon.component';
import { BusinessCompanyThingsInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-company-things-insurance-icon.component';
import { BusinessConstructionWarrantyInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-construction-warranty-icon.component';
import { BusinessCyberInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-cyber-insurance-icon.component';
import { BusinessHealthInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-health-insurance-icon.component';
import { BusinessLegalProtectionIconComponent } from '../ui-kit/icons/insurances-icons/business-legal-protection-insurance-icon.component';
import { BusinessRcCompanyInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-rc-company-insurance-icon.component';
import { BusinessRcProfessionalInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-rc-pro-insurance-icon.component';
import { BusinessRentalIconComponent } from '../ui-kit/icons/insurances-icons/business-rental-icon.component';
import { BusinessRetirementInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-retirement-insurance-icon.component';
import { BusinessTechnicalInstallationInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/business-technical-installation-insurance-icon.component';
import { ConstructionInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/construction-insurance-icon.component';
import { HealthInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/health-insurance-icon.component';
import { HouseholdInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/household-insurance-icon.component';
import { LegalProtectionInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/legal-protection-insurance-icon.component';
import { LifeInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/life-insurance-icon.component';
import { MotorVehicleInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/motor-vehicle-insurance-icon.component';
import { RentalGuaranteeIconComponent } from '../ui-kit/icons/insurances-icons/rental-guarantee-icon.component';
import { ThirdPillarInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/third-pillar-insurance-icon.component';
import { TravelInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/travel-insurance-icon.component';
import { ValuableObjectInsuranceIconComponent } from '../ui-kit/icons/insurances-icons/valuable-object-insurance-icon.component';
import { MergeIconComponent } from '../ui-kit/icons/merge-icon.component';
import { MoneyBillIconComponent } from '../ui-kit/icons/money-bill-icon.component';

export enum InsuranceTypeEnum {
  HEALTH = 'HEALTH',
  TRAVEL = 'TRAVEL',
  BUILDING = 'BUILDING',
  RC_HOUSEHOLD = 'RC_HOUSEHOLD',
  LEGAL_PROTECTION = 'LEGAL_PROTECTION',
  BUSINESS_LEGAL_PROTECTION = 'BUSINESS_LEGAL_PROTECTION',
  BUSINESS_COMPANY_THINGS = 'BUSINESS_COMPANY_THINGS',
  BUSINESS_RC_COMPANY = 'BUSINESS_RC_COMPANY',
  BUSINESS_RC_PROFESSIONAL = 'BUSINESS_RC_PROFESSIONAL',
  BUSINESS_ACCIDENT = 'BUSINESS_ACCIDENT',
  BUSINESS_ACCIDENT_COMPLEMENTARY = 'BUSINESS_ACCIDENT_COMPLEMENTARY',
  BUSINESS_RETIREMENT = 'BUSINESS_RETIREMENT',
  BUSINESS_HEALTH = 'BUSINESS_HEALTH',
  BUSINESS_TRAVEL = 'BUSINESS_TRAVEL',
  BUSINESS_CYBERSECURITY = 'BUSINESS_CYBERSECURITY',
  BUSINESS_RENTAL = 'BUSINESS_RENTAL',
  BUSINESS_CONSTRUCTION = 'BUSINESS_CONSTRUCTION',
  BUSINESS_BUILDING = 'BUSINESS_BUILDING',
  BUSINESS_MOTOR_VEHICLE = 'BUSINESS_MOTOR_VEHICLE',
  BUSINESS_CONSTRUCTION_WARRANTY = 'BUSINESS_CONSTRUCTION_WARRANTY',
  BUSINESS_THIRD_PILLAR = 'BUSINESS_THIRD_PILLAR',
  BUSINESS_FLEET = 'BUSINESS_FLEET',
  BUSINESS_MACHINERY = 'BUSINESS_MACHINERY',
  BUSINESS_MANIFESTATION = 'BUSINESS_MANIFESTATION',
  BUSINESS_LOSS = 'BUSINESS_LOSS',
  BUSINESS_TRANSPORT = 'BUSINESS_TRANSPORT',
  BUSINESS_TECHNICAL_INSTALLATION = 'BUSINESS_TECHNICAL_INSTALLATION',
  MOTOR_VEHICLE = 'MOTOR_VEHICLE',
  ANIMAL = 'ANIMAL',
  HOUSING_RENTAL = 'HOUSING_RENTAL',
  QUOTATION_REQUEST = 'QUOTATION_REQUEST',
  CONSTRUCTION = 'CONSTRUCTION',
  THIRD_PILLAR = 'THIRD_PILLAR',
  COMPLEMENTARY_HEALTH = 'COMPLEMENTARY_HEALTH',
  BENEFITS_ACCOUNT = 'BENEFITS_ACCOUNT',
  CENTRALISATION = 'CENTRALISATION',
  CANCELLATION = 'CANCELLATION',
  VALUABLE_OBJECTS = 'VALUABLE_OBJECTS',
  POLICY_UPDATE = 'POLICY_UPDATE',
  COLLABORATOR_DECLARATION = 'COLLABORATOR_DECLARATION',
  ACCIDENT = 'ACCIDENT',
  HEALTH_ALLOWANCE = 'HEALTH_ALLOWANCE',
}

export const getInsuranceTypeLabel = (type: InsuranceTypeEnum): string => {
  switch (type) {
    case InsuranceTypeEnum.HEALTH:
      return $localize`Caisse maladie`;
    case InsuranceTypeEnum.TRAVEL:
      return $localize`Voyage`;
    case InsuranceTypeEnum.BUILDING:
      return $localize`Bâtiment`;
    case InsuranceTypeEnum.RC_HOUSEHOLD:
      return $localize`RC ménage`;
    case InsuranceTypeEnum.LEGAL_PROTECTION:
      return $localize`Protection juridique`;
    case InsuranceTypeEnum.BUSINESS_LEGAL_PROTECTION:
      return $localize`Protection juridique entreprise`;
    case InsuranceTypeEnum.BUSINESS_COMPANY_THINGS:
      return $localize`Choses de l'entreprise`;
    case InsuranceTypeEnum.MOTOR_VEHICLE:
      return $localize`Véhicule à moteur`;
    case InsuranceTypeEnum.ANIMAL:
      return $localize`Animal`;
    case InsuranceTypeEnum.HOUSING_RENTAL:
      return $localize`Garantie de loyer`;
    case InsuranceTypeEnum.QUOTATION_REQUEST:
      return $localize`Demande de devis`;
    case InsuranceTypeEnum.CONSTRUCTION:
      return $localize`Construction`;
    case InsuranceTypeEnum.THIRD_PILLAR:
      return $localize`3ème pilier`;
    case InsuranceTypeEnum.COMPLEMENTARY_HEALTH:
      return $localize`Santé complémentaire`;
    case InsuranceTypeEnum.BENEFITS_ACCOUNT:
      return $localize`Compte de prestations`;
    case InsuranceTypeEnum.CENTRALISATION:
      return $localize`Centralisation`;
    case InsuranceTypeEnum.CANCELLATION:
      return $localize`Résiliation`;
    case InsuranceTypeEnum.VALUABLE_OBJECTS:
      return $localize`Objets de valeur`;
    case InsuranceTypeEnum.POLICY_UPDATE:
      return $localize`Demande de modification de police`;
    case InsuranceTypeEnum.BUSINESS_RC_COMPANY:
      return $localize`RC entreprise`;
    case InsuranceTypeEnum.BUSINESS_RC_PROFESSIONAL:
      return $localize`RC professionnelle`;
    case InsuranceTypeEnum.BUSINESS_ACCIDENT:
      return $localize`LAA`;
    case InsuranceTypeEnum.BUSINESS_ACCIDENT_COMPLEMENTARY:
      return $localize`LAAC`;
    case InsuranceTypeEnum.BUSINESS_RETIREMENT:
      return $localize`LPP`;
    case InsuranceTypeEnum.BUSINESS_HEALTH:
      return $localize`IJM`;
    case InsuranceTypeEnum.BUSINESS_TRAVEL:
      return $localize`Voyage`;
    case InsuranceTypeEnum.BUSINESS_CYBERSECURITY:
      return $localize`Cyber`;
    case InsuranceTypeEnum.BUSINESS_RENTAL:
      return $localize`Cyber`;
    case InsuranceTypeEnum.BUSINESS_CONSTRUCTION:
      return $localize`Construction entreprise`;
    case InsuranceTypeEnum.BUSINESS_BUILDING:
      return $localize`Bâtiment entreprise`;
    case InsuranceTypeEnum.BUSINESS_MOTOR_VEHICLE:
      return $localize`Véhicule à moteur entreprise`;
    case InsuranceTypeEnum.BUSINESS_CONSTRUCTION_WARRANTY:
      return $localize`Garantie d'ouvrage`;
    case InsuranceTypeEnum.BUSINESS_THIRD_PILLAR:
      return $localize`3ème pilier entreprise`;
    case InsuranceTypeEnum.BUSINESS_FLEET:
      return $localize`Flotte entreprise`;
    case InsuranceTypeEnum.BUSINESS_MACHINERY:
      return $localize`Machines / technique`;
    case InsuranceTypeEnum.BUSINESS_MANIFESTATION:
      return $localize`Manifestation`;
    case InsuranceTypeEnum.BUSINESS_LOSS:
      return $localize`Perte d'exploitation`;
    case InsuranceTypeEnum.BUSINESS_TRANSPORT:
      return $localize`Transport`;
    case InsuranceTypeEnum.COLLABORATOR_DECLARATION:
      return $localize`Annonce collaborateur`;
    case InsuranceTypeEnum.BUSINESS_TECHNICAL_INSTALLATION:
      return $localize`Installation technique`;
    case InsuranceTypeEnum.HEALTH_ALLOWANCE:
      return $localize`IJM privée`;
    case InsuranceTypeEnum.ACCIDENT:
      return $localize`LAA privée`;
    default:
      return '';
  }
};

export const getInsuranceTypeIcon = (type: InsuranceTypeEnum): ComponentType<BaseIconComponent> => {
  switch (type) {
    case InsuranceTypeEnum.HEALTH:
      return HealthInsuranceIconComponent;
    case InsuranceTypeEnum.TRAVEL:
      return TravelInsuranceIconComponent;
    case InsuranceTypeEnum.BUILDING:
      return BuildingInsuranceIconComponent;
    case InsuranceTypeEnum.RC_HOUSEHOLD:
      return HouseholdInsuranceIconComponent;
    case InsuranceTypeEnum.LEGAL_PROTECTION:
      return LegalProtectionInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_LEGAL_PROTECTION:
      return BusinessLegalProtectionIconComponent;
    case InsuranceTypeEnum.BUSINESS_COMPANY_THINGS:
      return BusinessCompanyThingsInsuranceIconComponent;
    case InsuranceTypeEnum.MOTOR_VEHICLE:
      return MotorVehicleInsuranceIconComponent;
    case InsuranceTypeEnum.ANIMAL:
      return AnimalInsuranceIconComponent;
    case InsuranceTypeEnum.HOUSING_RENTAL:
      return RentalGuaranteeIconComponent;
    case InsuranceTypeEnum.QUOTATION_REQUEST:
      return MoneyBillIconComponent;
    case InsuranceTypeEnum.CONSTRUCTION:
      return ConstructionInsuranceIconComponent;
    case InsuranceTypeEnum.THIRD_PILLAR:
      return ThirdPillarInsuranceIconComponent;
    case InsuranceTypeEnum.COMPLEMENTARY_HEALTH:
      return LifeInsuranceIconComponent;
    case InsuranceTypeEnum.BENEFITS_ACCOUNT:
      return MoneyBillIconComponent;
    case InsuranceTypeEnum.CENTRALISATION:
      return MergeIconComponent;
    case InsuranceTypeEnum.VALUABLE_OBJECTS:
      return ValuableObjectInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_RC_COMPANY:
      return BusinessRcCompanyInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_RC_PROFESSIONAL:
      return BusinessRcProfessionalInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_ACCIDENT:
    case InsuranceTypeEnum.ACCIDENT:
      return BusinessAccidentInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_RETIREMENT:
      return BusinessRetirementInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_HEALTH:
    case InsuranceTypeEnum.HEALTH_ALLOWANCE:
      return BusinessHealthInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_TRAVEL:
      return TravelInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_CYBERSECURITY:
      return BusinessCyberInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_RENTAL:
      return BusinessRentalIconComponent;
    case InsuranceTypeEnum.BUSINESS_CONSTRUCTION:
      return ConstructionInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_BUILDING:
      return BusinessBuildingInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_MOTOR_VEHICLE:
      return MotorVehicleInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_CONSTRUCTION_WARRANTY:
      return BusinessConstructionWarrantyInsuranceIconComponent;
    case InsuranceTypeEnum.BUSINESS_TECHNICAL_INSTALLATION:
      return BusinessTechnicalInstallationInsuranceIconComponent;
    default:
      return null;
  }
};
